module.exports = __webpack_public_path__ + "img/logo_CCIAA_white.be7fff95.png";